(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[74221],{

/***/ 74221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ FeatureList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/page-builder/components/featureList/styles.module.scss
var styles_module = __webpack_require__(18837);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./src/page-builder/components/featureList/featureListItem.tsx





function areOrdersEqual(prev, next) {
    if (prev === next) return true;
    if (prev.length !== next.length) return false;
    return prev.every((key, index)=>key === next[index]);
}
function areFeatureListItemPropsEqual(prev, next) {
    return prev.item === next.item && prev.index === next.index && prev.itemLayout === next.itemLayout && prev.isHorizontalButtons === next.isHorizontalButtons && prev.showCounter === next.showCounter && areOrdersEqual(prev.order, next.order) && prev.basePlaceholders.region === next.basePlaceholders.region && prev.basePlaceholders.city === next.basePlaceholders.city && prev.postPlaceholders.postUpdatedDate === next.postPlaceholders.postUpdatedDate && prev.postPlaceholders.readingTime === next.postPlaceholders.readingTime && prev.renderListItems === next.renderListItems && prev.renderAction === next.renderAction;
}
function FeatureListItem({ item , index , order , itemLayout , isHorizontalButtons , showCounter , basePlaceholders , postPlaceholders , renderListItems , renderAction  }) {
    const contentByKey = order.reduce((acc, key)=>{
        if (key === "title") {
            acc[key] = item.href && item.href.trim() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: item.href,
                className: (styles_module_default())["item-href"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: `font-medium text-lg lg:text-xl ${(styles_module_default())["item-title"]}`,
                    dangerouslySetInnerHTML: {
                        __html: (0,sharedUtils/* replacePlaceholders */.wT)(item.title ?? "", basePlaceholders)
                    }
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `font-medium text-lg lg:text-xl ${(styles_module_default())["item-title"]}`,
                dangerouslySetInnerHTML: {
                    __html: (0,sharedUtils/* replacePlaceholders */.wT)(item.title ?? "", postPlaceholders)
                }
            });
        } else if (key === "description") {
            acc[key] = item.showList ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: Array.isArray(item.list) && renderListItems(item.list)
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "font-light text-sm text-center",
                children: (0,sharedUtils/* replacePlaceholders */.wT)(item.description ?? "", basePlaceholders)
            });
        } else if (key === "list" && !item.showList) {
            acc[key] = Array.isArray(item.list) && item.list.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: renderListItems(item.list)
            }) : null;
        } else if (key === "note") {
            acc[key] = item.note ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `font-light text-sm ${(styles_module_default())["item-note"]}`,
                dangerouslySetInnerHTML: {
                    __html: item.note
                }
            }) : null;
        } else if (key === "image") {
            if (showCounter) {
                acc[key] = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: `flex ${(styles_module_default()).imageContainer}`,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).counter,
                        children: index + 1
                    })
                });
            } else if (item.image) {
                acc[key] = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: `flex ${(styles_module_default()).imageContainer}`,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: `relative w-full ${(styles_module_default()).image}`,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: item.image,
                            layout: "fill",
                            alt: item.title
                        })
                    })
                });
            } else {
                acc[key] = null;
            }
        } else if (key === "button") {
            acc[key] = renderAction(item);
        } else {
            acc[key] = null;
        }
        return acc;
    }, {});
    const orderedContent = order.map((key)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
            children: contentByKey[key] ?? null
        }, key));
    const itemClasses = `${(styles_module_default()).item} ${itemLayout === "horizontal" ? (styles_module_default()).horizontal : "flex-col"}`;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: `flex ${itemClasses}`,
        children: itemLayout === "horizontal" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).imageColumn,
                    children: contentByKey.image ?? null
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).contentColumn,
                    children: order.filter((key)=>{
                        if (key === "image") {
                            return false;
                        }
                        if (key === "button" && isHorizontalButtons) {
                            return false;
                        }
                        return true;
                    }).map((key)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: contentByKey[key] ?? null
                        }, key))
                }),
                isHorizontalButtons && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).buttonColumn,
                    children: contentByKey.button ?? null
                })
            ]
        }) : orderedContent
    });
}
/* harmony default export */ var featureListItem = (/*#__PURE__*/(0,react.memo)(FeatureListItem, areFeatureListItemPropsEqual));

// EXTERNAL MODULE: ./src/page-builder/utils/index.tsx
var utils = __webpack_require__(42001);
;// CONCATENATED MODULE: ./src/page-builder/components/featureList/index.tsx








const DEFAULT_ORDER = [
    "image",
    "title",
    "description",
    "note",
    "list",
    "button", 
];
const DEFAULT_GRID_COLUMNS = {
    sm: 1,
    md: 2,
    lg: 3,
    xl: 3
};
function FeatureList({ props ={}  }) {
    const { visitDetails , pageBuilderBlogPost  } = (0,useDomainContext/* useDomainContext */.w)();
    const { title , description , items , order =DEFAULT_ORDER , gridColumns =DEFAULT_GRID_COLUMNS , itemLayout ="vertical" , showCounter =false , buttonLayout ="vertical" ,  } = props;
    const isHorizontalButtons = buttonLayout === "horizontal";
    const postUpdatedDate = pageBuilderBlogPost ? (0,utils/* getPublishedDateLabel */.H1)(pageBuilderBlogPost) : undefined;
    const readingTime = pageBuilderBlogPost ? (0,utils/* getPostReadingTime */.Xm)(pageBuilderBlogPost) : undefined;
    const basePlaceholders = (0,react.useMemo)(()=>({
            region: visitDetails.region,
            city: visitDetails?.city
        }), [
        visitDetails.region,
        visitDetails?.city
    ]);
    const postPlaceholders = (0,react.useMemo)(()=>({
            ...basePlaceholders,
            postUpdatedDate,
            readingTime
        }), [
        basePlaceholders,
        postUpdatedDate,
        readingTime
    ]);
    const gridStyle = (0,react.useMemo)(()=>({
            "--grid-cols-sm": gridColumns["sm"] || "1",
            "--grid-cols-md": gridColumns["md"] || gridColumns["sm"] || "2",
            "--grid-cols-lg": gridColumns["lg"] || gridColumns["md"] || gridColumns["sm"] || "3",
            "--grid-cols-xl": gridColumns["xl"] || gridColumns["lg"] || gridColumns["md"] || gridColumns["sm"] || "3"
        }), [
        gridColumns["sm"],
        gridColumns["md"],
        gridColumns["lg"],
        gridColumns["xl"], 
    ]);
    const renderListItems = (0,react.useCallback)((list)=>{
        return list.map((listItem, listIndex)=>{
            const isObject = typeof listItem === "object";
            const text = isObject ? listItem.text : listItem;
            const icon = isObject ? listItem.icon : undefined;
            const itemKey = `${text}-${icon ?? "no-icon"}-${listIndex}`;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                className: (styles_module_default()).listItem,
                children: [
                    icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).listIcon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: icon,
                            layout: "fill",
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (styles_module_default()).listText,
                        children: (0,sharedUtils/* replacePlaceholders */.wT)(text ?? "", basePlaceholders)
                    })
                ]
            }, itemKey);
        });
    }, [
        basePlaceholders
    ]);
    const renderAction = (0,react.useCallback)((item)=>{
        const buttonData = item.button;
        if (!buttonData?.text && !buttonData?.icon) return null;
        const content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                buttonData.showIcon && buttonData.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).buttonIcon,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: buttonData.icon,
                        layout: "fill",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: buttonData.text
                })
            ]
        });
        const buttonClassName = `${(styles_module_default())["item-button"]} ${buttonData.showIcon ? (styles_module_default())["button-with-icon"] : ""}`;
        if (!buttonData.download) {
            if (!buttonData.href) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: buttonClassName,
                    children: content
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: buttonData.href,
                className: `${buttonClassName} ${(styles_module_default())["button-link"]}`,
                target: buttonData.target || "_blank",
                rel: "noopener noreferrer",
                children: content
            });
        }
        const handleDownload = ()=>{
            if (!buttonData.href) return;
            const filename = buttonData.pdfFileName ? buttonData.pdfFileName : buttonData.href?.split("/")?.pop() || "download";
            const downloadUrl = `/api/download?url=${encodeURIComponent(buttonData.href)}&filename=${encodeURIComponent(filename)}`;
            window.location.href = downloadUrl;
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            type: "button",
            className: buttonClassName,
            onClick: handleDownload,
            children: content
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (styles_module_default()).mainSection,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: `mb-6 ${(styles_module_default()).title}`,
                    dangerouslySetInnerHTML: {
                        __html: (0,sharedUtils/* replacePlaceholders */.wT)(title, basePlaceholders)
                    }
                }),
                description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: (0,sharedUtils/* replacePlaceholders */.wT)(description, basePlaceholders)
                    },
                    className: (styles_module_default()).description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: gridStyle,
                    className: `grid gap-10 lg:gap-20 mt-6 ${(styles_module_default()).grid} itemsContainer`,
                    children: items?.map((item, index)=>{
                        const featureKey = item.href?.trim() || item.title?.trim() || `feature-item-${index}`;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(featureListItem, {
                            item: item,
                            index: index,
                            order: order,
                            itemLayout: itemLayout,
                            isHorizontalButtons: isHorizontalButtons,
                            showCounter: showCounter,
                            basePlaceholders: basePlaceholders,
                            postPlaceholders: postPlaceholders,
                            renderListItems: renderListItems,
                            renderAction: renderAction
                        }, featureKey);
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 18837:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","item":"styles_item__mATNO","horizontal":"styles_horizontal__qhDD_","imageColumn":"styles_imageColumn__MW1X5","imageContainer":"styles_imageContainer__FPUbH","contentColumn":"styles_contentColumn__Z7vKP","item-title":"styles_item-title__DaJeV","item-note":"styles_item-note__xLuEB","buttonColumn":"styles_buttonColumn__3c0_V","item-button":"styles_item-button___3EV9","mainSection":"styles_mainSection__cN_bX","title":"styles_title__0zChl","description":"styles_description__JA8qL","grid":"styles_grid__6zJUZ","item-href":"styles_item-href__q_9SD","image":"styles_image__Cyv20","counter":"styles_counter__Hwd4l","link":"styles_link__me_Gm","listItem":"styles_listItem__WuquU","listIcon":"styles_listIcon__XKJ1b","listText":"styles_listText__2b_JV","button-with-icon":"styles_button-with-icon__LeASp","buttonIcon":"styles_buttonIcon__hrAVs","button-link":"styles_button-link__DDS7a"};

/***/ })

}]);